import {
  http,
  delay,
  HttpResponse,
} from 'msw';

import { createMockEndpoint } from '@/mocks/create-mock-endpoint';
import {
  MailAuthenticationRequest,
  MailAuthenticationResponse,
} from '@/repositories/generated';
import { ErrorBody } from '@/types';

export const mailAuth = http.post(
  createMockEndpoint('/auth/mail'),
  async ({ request }) => {
    const requestBody = await request.json() as MailAuthenticationRequest;
    await delay(500);

    const createResponse = (): ErrorBody | MailAuthenticationResponse => {
      switch (requestBody.validateCode) {
        case '000000':
          return {
            error: {
              code: 'ERR-D999-0022',
              message: 'MOCK_ERROR: 確認コードをご確認の上、再度認証してください。',
            },
          };
        case '111000':
          return {
            status: 'CHANGE_PASSWORD',
          };
        case '111111':
        default:
          return {
            status: 'SUCCESS',
          };
      }
    };

    const response = createResponse();
    const statusCode = 'error' in response ? 401 : 200;

    return HttpResponse.json(response, { status: statusCode });
  },
);
